<template>
  <div>
    <h5 class="mb-3">Товары / услуги тендера №{{ tenderId }}</h5>

    <!-- ===== Кнопки ===== -->
    <div class="d-flex gap-2 mb-3">
      <input ref="file" type="file" accept=".xlsx,.xls"
             class="form-control form-control-sm w-auto"
             @change="importExcel">
      <button class="btn btn-sm btn-outline-primary" @click="download">
        <i class="fa-solid fa-download me-1"/>Скачать Excel
      </button>
    </div>

    <!-- ===== Таблица ===== -->
    <div class="table-responsive" v-if="rows.length">
      <table class="table table-sm table-bordered align-middle">
        <thead class="table-light">
          <tr>
            <th style="width:40px">№</th>
            <th>Наименование</th>
            <th style="width:100px">Тип</th>
            <th style="width:120px" class="text-end">Цена</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(r,i) in rows" :key="r.id">
            <td>{{ i+1 }}</td>
            <td>{{ r.name }}</td>
            <td>{{ r.type || '—' }}</td>
            <td class="text-end">{{ money(r.internal_price??r.price_from_docs) }}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <p v-else class="text-muted">Позиции не найдены.</p>
  </div>
</template>

<script setup>
import { ref, onMounted, computed, watch } from 'vue'
import api from '../api'
import * as XLSX from 'xlsx'
import { saveAs } from 'file-saver'
import { resolveTenderPlanId } from '../utils/tender-id'

const props = defineProps({ tenderId: [Number, String, Object] })
const rows  = ref([])
const money = v => v!=null
  ? new Intl.NumberFormat('ru-RU',{style:'currency',currency:'RUB'}).format(v)
  : '—'

const tenderPlanId = computed(() => resolveTenderPlanId(props.tenderId))

onMounted(load)
watch(tenderPlanId, () => load())

async function load () {
  const id = tenderPlanId.value
  if (!id) return
  const { data } = await api.get(`/tenders/${id}/analysis/`)
  rows.value = data.items || []
}

/* ---------------- excel download ---------------- */
function download () {
  if (!rows.value.length) return
  const data = rows.value.map((r,i)=>({
    'Номер': i+1,
    'Наименование': r.name,
    'Тип': r.type||'',
    'Цена': r.internal_price??r.price_from_docs??''
  }))
  const ws = XLSX.utils.json_to_sheet(data, { header:[
    'Номер','Наименование','Тип','Цена' ]})
  const wb = XLSX.utils.book_new()
  XLSX.utils.book_append_sheet(wb,ws,'Items')
  const buf = XLSX.write(wb,{type:'array',bookType:'xlsx'})
  const id = tenderPlanId.value || 'unknown'
  saveAs(new Blob([buf]), `tender_${id}_items.xlsx`)
}

/* ---------------- excel import ---------------- */
const file = ref(null)
async function importExcel (e) {
  const f = e.target.files[0]
  if (!f) return
  const fd = new FormData()
  fd.append('file', f)
  try {
    const id = tenderPlanId.value
    if (!id) throw new Error('tender id missing')
    await api.post(
      `/tenders/${id}/items/excel/`, fd,
      { headers:{'Content-Type':'multipart/form-data'} }
    )
    await load()
    alert('Данные из Excel применены')
  } catch (err) {
    console.error(err)
    alert('Не удалось обработать файл')
  } finally {
    file.value.value = ''     // сброс <input>
  }
}
</script>
